export class DeployTemplate {
    id: number;
    appKey: string;
    name: string;
    env: string;
    param: DeployParam;
    description: string;
    state: string;
    createTime: Date;
    updateTime: Date;
}

export class DeployParam {
    port: number;
    checkPath: string;
    maxCheckSeconds: number;
    checkInterval: number;
    enableRemoteDebug: boolean;
    debugPort: number;
    licenseKey: string;
    concurrency: number;
    stopWhenFailed: boolean;

    customJvmArgs?: string;
    packageName?: string;

    static ofDefault(): DeployParam {
        return {
            port: 8080,
            checkPath: "/aliveStatus",
            maxCheckSeconds: 120,
            checkInterval: 5,
            enableRemoteDebug: false,
            debugPort: 8418,
            licenseKey: "",
            concurrency: 1,
            stopWhenFailed: true,
        };
    }
}